module.exports = require("core-js/library/fn/is-iterable");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime/core-js/is-iterable.js
// module id = 224
// module chunks = 0 2